import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { Card } from 'src/components';

import {
  CyprIcon,
  CyprLogo,
  DefaultBlot,
  FcaIcon,
  FcaLogo,
  LightEllipse,
  SfcIcon,
  SfcLogo,
} from 'src/assets';
import './licenses.scss';
import { useAnimatedView } from 'src/hooks/useAnimatedView';

export const Licenses = () => {
  const { t } = useTranslation();

  const licensesData = [
    {
      logo: FcaLogo,
      icon: FcaIcon,
      title: 'FCA',
      subTitle: t('licenses:fcaSub'),
    },
    {
      logo: CyprLogo,
      icon: CyprIcon,
      title: 'CySEC',
      subTitle: t('licenses:cyprSub'),
    },
    {
      logo: SfcLogo,
      icon: SfcIcon,
      title: 'SFC',
      subTitle: t('licenses:sfcSub'),
    },
  ];

  const ref = useRef();
  const { isVisible } = useAnimatedView(ref);

  return (
    <div className="licenses">
      <div className={`licenses-content ${isVisible ? 'active-animation' : ''}`} ref={ref}>
        <div className="licenses-title">
          <supertitle className="licenses-supertitle">{t('licenses:supertitle')}</supertitle>
          <h1 className="licenses-title-heading">
            {t('licenses:valuable')} <blue-underline>{t('licenses:licenses')}</blue-underline>{' '}
            {t('licenses:by')} <blue-text>{t('licenses:regulations')}</blue-text>
          </h1>
        </div>

        <div className="licenses-card-wrapper">
          {licensesData.map((item) => (
            <div className="licenses-card" key={item.title}>
              <Card type="white">
                <div className="licenses-card-content">
                  <img className="licenses-card-logo" src={item.logo} alt={item.logo} />
                  <div className="licenses-card-block">
                    <img className="licenses-card-icon" src={item.icon} alt={item.icon} />
                    <div className="licenses-card-text">
                      <h3 className="licenses-card-title">{item.title}</h3>
                      <div className="licenses-card-subtitle">{item.subTitle}</div>
                    </div>
                  </div>
                </div>
              </Card>
            </div>
          ))}
        </div>

        <img src={LightEllipse} alt={LightEllipse} className="licenses-image-1" />
        <img src={DefaultBlot} alt={DefaultBlot} className="licenses-image-2" />
      </div>
    </div>
  );
};
